import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";
import utils from "../../Utils";
import Constants from "../../Constants";

import * as rules                  from 'vee-validate/dist/rules';
import en                        from 'vee-validate/dist/locale/en.json';
import {extend, localize, setInteractionMode, ValidationObserver, ValidationProvider} from 'vee-validate';

// -------------------------------------------------------
//                  VeeValidate 設定
// -------------------------------------------------------
localize('en', en);
setInteractionMode('eager');

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

const components = _.assign(ComponentSet, { ValidationProvider, ValidationObserver,} );

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data() {
        return {
            lastName        : "",
            firstName       : "",
            phone           : "",
            email           : "",
            department      : "",
            questionCategory: "",
            opinion         : "",
            exceptionBranch : "6",
            exceptionOption : {"Latest news": "最新消息", "Service opinion": "服務意見", "About the website": "關於網站"},
            defaultOption   : {"Medical service": "醫療服務", "Health Advisory": "健康諮詢", "About the website": "關於網站"},
        }
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData();
        //this.showMessage({ config: { msg: '查無此資訊。', title: 123 } });
    },
    methods: {
        onBranchSelected(){
            let self = this
            $("#questionCategory").empty();
            // if($("#department option:first").val() == "") {
            //     $("#department option:first").remove();
            // }
            $("#questionCategory").append('<option value="" >Please select</option>')
            if(self.department === self.exceptionBranch){
                $.each(self.exceptionOption, function(key, value){
                    $("#questionCategory").append('<option value="'+value+'" >'+key+'</option>')
                });
            }
            else{
                $.each(self.defaultOption, function(key, value){
                    $("#questionCategory").append('<option value="'+value+'" >'+key+'</option>')
                });
            }

            this.questionCategory = "";
        },
        clearData(){
            this.lastName         = "";
            this.firstName        = "";
            this.phone            = "";
            this.email            = "";
            this.opinion          = "";
            this.department       = "";
            this.questionCategory = "";
            
            $('#rd_contact_form input').val('');
            $("#questionCategory").empty();
            $("#questionCategory").append('<option value="" >Please select</option>')
        },
        submitData(){
            let _this = this
            
            _.set(this, 'contentData.form.lastName', this.lastName);
            _.set(this, 'contentData.form.firstName', this.firstName)
            _.set(this, 'contentData.form.phone', this.phone)
            _.set(this, 'contentData.form.email', this.email)
            _.set(this, 'contentData.form.department', this.department)
            _.set(this, 'contentData.form.questionCategory', this.questionCategory)
            _.set(this, 'contentData.form.opinion', this.opinion)
            
            this.postData(Constants.serverRoot+"/contact/save", "form", "form", "pageData.contentData.form", () => {
                _this.clearData();
                this.$refs.observer.reset();
                _this.showMessage({ config: { msg: 'Success' } });
            });
        }
    }, // end of methods
    computed: {
        branchList() {
            return _.get(this, 'contentData.branchList', []) || [];
        },

    }, // end of computed
}).$mount('#app');